const imageClicked = (image) => ({
  type: "s2r/imageClicked",
  image: image,
});

const renderSelected = (image) => ({
  type: "s2r/renderSelected",
  image: image,
});

const sketchSelected = (image) => ({
  type: "s2r/sketchSelected",
  image: image,
});

const imageAdded = (image) => ({
  type: "s2r/imageAdded",
  image: image,
});

const imageDeleted = (id) => ({
  type: "s2r/imageDeleted",
  payload: id,
});

const imageEdited = (image) => ({
  type: "s2r/imageEdited",
  image: image,
});

const undo = (image) => ({
  type: "s2r/undo",
  image: image,
});

const shaderOptionChanged = (shader) => ({
  type: "s2r/shaderOptionChanged",
  shader: shader,
});

const updateLevels = (imageVersion) => ({
  type: "s2r/updateLevels",
  imageVersion: imageVersion,
});

const renderImageStarted = (image) => ({
  type: "s2r/renderImageStarted",
  image: image,
  status: "loading",
});

const renderImageFinished = (image) => ({
  type: "s2r/renderImageFinished",
  image: image,
  status: null,
});

const renderImageError = (e) => ({
  type: "s2r/renderImageError",
  error: e,
  status: null,
});

const shaderTutorialToggled = (option) => ({
  type: "s2r/shaderTutorialToggled",
  option: option,
});

const contactOpen = (option) => ({
  type: "s2r/contactOpen",
  option: option,
});

const onyxImageSampleExists = (option) => ({
  type: "s2r/onyxImageSampleExists",
  option: option,
});

const SKRActions = {
  undo,
  imageAdded,
  imageEdited,
  imageClicked,
  imageDeleted,
  sketchSelected,
  renderSelected,
  shaderOptionChanged,
  updateLevels,
  renderImageStarted,
  renderImageFinished,
  renderImageError,
  shaderTutorialToggled,
  contactOpen,
  onyxImageSampleExists,
};

export default SKRActions;
